import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import styles from 'AppRoutes/BeerStoreError/styles';

const GrowlerError: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={styles.container}>
      <Card sx={styles.card}>
        <CardContent sx={styles.content}>
          <ErrorOutlineIcon color="error" sx={styles.icon} />
          <Typography variant="h4" sx={styles.title}>
            Algo deu errado!
          </Typography>
          <Typography variant="body1" sx={styles.message}>
            Não conseguimos processar sua compra de growlers.
            <br />
            Tente novamente ou entre em contato com nosso suporte.
          </Typography>
          <Button
            variant="contained"
            color="error"
            sx={styles.button}
            onClick={() => navigate('/growlers')}
          >
            Voltar para growlers
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default GrowlerError;
